export const SUPPORTS_PROXY = typeof Proxy !== "undefined";
